import { getMemberInfo } from '../api/getMemberInfo';
import { useSuspenseQuery } from '@tanstack/react-query';
import { queryKey } from 'shared/src/constant';

export const useMyInfo = () => {
  return useSuspenseQuery({
    queryKey: queryKey.myInfo,
    queryFn: getMemberInfo,
  });
};
